import styled from 'styled-components';
const MemberDetailStyled = styled.div`
  border-radius: 12px;
  background-color: #fff;
  height: 100%;
  padding: 24px 32px;
  padding-bottom: 32px;
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    /* .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    } */
  }
  .form-container {
    flex-direction: column;
  }
  .row {
    gap: 96px;
    margin-bottom: 32px;
    display: flex;
    > div {
      flex: 1;
    }
  }
`;
export default MemberDetailStyled;
